import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  updateHomePageDataFetched,
  updateHomePageFilterModal,
  updateHomePageSortBy,
  updateHomePageDeals,
  updateHomePageFilteredDeals,
  updateHomePagePriceRangeTextBoxes,
  updateHomePageFilterCategories,
  updateHomePageSearchKeyWords
} from '../../reducers/homePageReducer';
import {Modal, Input, Icon, Button, Dropdown} from 'semantic-ui-react';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import reduce from 'lodash/reduce';
import orderBy from 'lodash/orderBy';
import {sampleLaptopDeals} from '../../lib/laptop';
import {NavbarFilter} from '../NavbarFilter/NavbarFilter';
import './HomePage.css';

class HomePage extends Component {
  constructor(props) {
    super(props);

    window.mixpanel.track('Homepage Visited', {
    });

    this.populateFilters = this.populateFilters.bind(this);
    this.resetPriceRangeTextboxes = this.resetPriceRangeTextboxes.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handlePriceRangeTextBoxChange = this.handlePriceRangeTextBoxChange.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleDropDownChange = this.handleDropDownChange.bind(this);
    this.beautifyStorage = this.beautifyStorage.bind(this);
    this.handleReferralButtonClick = this.handleReferralButtonClick.bind(this);

    if (!this.props.homePageDataFetched) {
      const dealsProcessed = Array.from(sampleLaptopDeals);
      for (const deal of dealsProcessed) {
        deal.searchDescription =
          deal.title + ' ' +
          '$' + deal.price + ' ' +
          deal.screen.size + '" ' +
          deal.screen.resolution.width + 'X' + deal.screen.resolution.height + ' ' +
          deal.screen.panelType + ' Screen ' +
          deal.cpu.clockSpeed + ' GHZ ' + deal.cpu.cores + '-Core ' + deal.cpu.manufacturer + ' ' +
          deal.cpu.model + ' Processor ' +
          deal.ram.size + ' GB ' + deal.ram.sodimm + ' RAM ' +
          deal.gpu.type + ' ' + deal.gpu.manufacturer + ' ' + deal.gpu.model + ' ' +
          deal.gpu.vram + ' ' + deal.gpu.vram + ' GB  Graphics ' +
          deal.gpu.vram + ' Graphics ' +
          deal.hardDisks[0].size + ' GB ' + deal.hardDisks[0].type + ' ' +
          deal.hardDisks[0].size/1000.0 + ' TB ' + deal.hardDisks[0].type + ' ' +
          deal.weight + ' lbs ' +
          deal.storeDisplayName;
      }
      this.props.updateHomePageDeals(dealsProcessed);
      this.props.updateHomePageFilteredDeals(dealsProcessed);
      this.populateFilters(dealsProcessed);
      this.props.updateHomePageDataFetched(true);
    }
    this.resetPriceRangeTextboxes();
  }

  componentDidMount() {
  }

  populateFilters(laptopDeals) {
    const manufacturerSet = new Set();
    const screenSizeSet = new Set();
    const resolutionArrWithDuplicates = [];
    const gpuRamSizeSet = new Set();
    const portTypeSet = new Set();
    laptopDeals.forEach(
      deal => {
        // update price range

        // add to manufacturer set
        manufacturerSet.add(deal.manufacturer);

        // add to screen size set
        screenSizeSet.add(deal.screen.size);

        // skipping panelType b/c it's hard coded (IPS, TN, Other)

        // add to resolution array (will remove duplicates later)
        resolutionArrWithDuplicates.push({...deal.screen.resolution, uniqueKey: deal.screen.resolution.width + 'x' + deal.screen.resolution.height});

        // skipping touchscreen b/c it's hard coded (checked, not checked)

        // skipping weights b/c it's hard coded (feather, light, medium, heavy, brick)

        // skipping cpu manufacturers b/c it's hard coded (Intel, AMD)

        // skipping cpu cores b/c it's hard coded (1, 2, 4, 6, 6+)

        // skipping ram sizes b/c it's hard coded

        // skipping hd types b/c it's hard coded

        // skipping hd sizes b/c it's hard coded

        // skipping gpu types b/c it's hard coded

        // skipping gpu manufacturers b/c it's hard coded

        // add to gpu ram size set
        gpuRamSizeSet.add(deal.gpu.vram);

        // skipping OS b/c it's hard coded

        // add to port type set
        deal.ports.forEach(
          port => {
            portTypeSet.add(port.type);
          }
        );

        // skipping optical drive b/c it's hard coded (checked, not checked)

        // skipping webcam b/c it's hard coded (checked, not checked)

        // skipping bluetooth b/c it's hard coded (checked, not checked)
      }
    );
    const newHomePageFilterCategories = {...this.props.homePageLaptopCategories};

    // flatten manufacturer set to array, sort it, and set value
    let manufacturersArr = [...manufacturerSet];
    manufacturersArr.sort();
    manufacturersArr = manufacturersArr.map(x => { return {brand: x, checked: false}});
    newHomePageFilterCategories.manufacturers = manufacturersArr;

    // flatten screen set to array, sort it, and set value
    let screenSizesArr = [...screenSizeSet];
    screenSizesArr.sort();
    screenSizesArr = screenSizesArr.map(x => { return {screenSize: x, checked: false}});
    newHomePageFilterCategories.screenSizes = screenSizesArr;

    // skipping panelType b/c it's hard coded (IPS, TN, Other)

    // flatten screen resolution set to array, sort it, and set value
    let resolutionsArr = uniqBy([...resolutionArrWithDuplicates], 'uniqueKey');
    resolutionsArr.sort(function (a, b) {
      return (a.width * a.height) - b.width * b.height;
    });
    resolutionsArr = resolutionsArr.map(x => { return {resolution: x, checked: false}});
    newHomePageFilterCategories.resolutions = resolutionsArr;

    // skipping touchscreen b/c it's hard coded (checked, not checked)

    // skipping weights /bc it's hard coded (feather, light, medium, heavy, brick)

    // skipping cpu manufacturers b/c it's hard coded (Intel, AMD)

    // skipping cpu cores b/c it's hard coded (1, 2, 4, 6, 6+)

    // skipping ram sizes b/c it's hard coded

    // skipping hd types b/c it's hard coded

    // skipping hd sizes b/c it's hard coded

    // skipping gpu types b/c it's hard coded

    // skipping gpu manufacturers b/c it's hard coded

    // flatten manufacturer set to array, sort it, and set value
    let gpuRamsArr = [...gpuRamSizeSet];
    gpuRamsArr.sort();
    gpuRamsArr = gpuRamsArr.map(x => { return {gpuRamSize: x, checked: false}});
    newHomePageFilterCategories.gpuRamSizes = gpuRamsArr;

    // skipping OS b/c it's hard coded

    // flatten screen set to array, sort it, and set value
    let portTypesArr = [...portTypeSet];
    portTypesArr.sort();
    portTypesArr = portTypesArr.map(x => { return {portType: x, checked: false}});
    newHomePageFilterCategories.portTypes = portTypesArr;

    // skipping optical drive b/c it's hard coded (checked, not checked)

    // skipping webcam b/c it's hard coded (checked, not checked)

    // skipping bluetooth b/c it's hard coded (checked, not checked)

    this.props.updateHomePageFilterCategories(newHomePageFilterCategories);
  }

  static filterDeals(deals, filterCategories, keywords) {
    return deals.filter(function(deal) {

      const keywordsProcessed = keywords.trim().toLocaleUpperCase();
      if (keywordsProcessed.length &&
          !deal.searchDescription.toLocaleUpperCase().includes(keywordsProcessed)) {
        return false;
      }

      if (filterCategories.priceRange.low !== -1 &&
          filterCategories.priceRange.high !== -1) {
        if (deal.price < filterCategories.priceRange.low ||
            deal.price > filterCategories.priceRange.high) {
          return false;
        }
      }

      // only filter if >=1 category is checked

      for (const m of filterCategories.manufacturers) {
        if (m.checked && !reduce(filterCategories.manufacturers, function (status, m) {
          if (m.checked &&
            m.brand.toLocaleUpperCase() === deal.manufacturer.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.screenSizes) {
        if (m.checked && !reduce(filterCategories.screenSizes, function (status, m) {
          if (m.checked &&
            m.screenSize === Number(deal.screen.size)) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.panelTypes) {
        if (m.checked && !reduce(filterCategories.panelTypes, function (status, m) {
          if (m.checked &&
            (m.panelType.toLocaleUpperCase() === deal.screen.panelType.toLocaleUpperCase() ||
              (m.panelType === 'TN' && deal.screen.panelType !== 'IPS'))
          /* m.panelType.toLocaleUpperCase() === deal.screen.panelType.toLocaleUpperCase()*/) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.resolutions) {
        if (m.checked && !reduce(filterCategories.resolutions, function (status, m) {
          if (m.checked &&
            m.resolution.width === deal.screen.resolution.width &&
            m.resolution.height === deal.screen.resolution.height) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      if (filterCategories.touchscreen.checked && !deal.screen.touchscreen) {
        return false;
      }

      for (const m of filterCategories.weights) {
        if (m.checked && !reduce(filterCategories.weights, function (status, m) {
          if (m.checked &&
            (m.type === 'Feather' && deal.weight <= 2.5)) {
            return true;
          } else if (m.checked &&
            (m.type === 'Light' && deal.weight > 2.5 && deal.weight <= 4)) {
            return true;
          } else if (m.checked &&
            (m.type === 'Medium' && deal.weight > 4 && deal.weight <= 5)) {
            return true;
          } else if (m.checked &&
            (m.type === 'Light' && deal.weight > 5 && deal.weight <= 7)) {
            return true;
          } else if (m.checked &&
            (m.type === 'Brick' && deal.weight > 7)) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.cpuManufacturers) {
        if (m.checked && !reduce(filterCategories.cpuManufacturers, function (status, m) {
          if (m.checked &&
            m.manufacturer.toLocaleUpperCase() === deal.cpu.manufacturer.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.cpuCores) {
        if (m.checked && !reduce(filterCategories.cpuCores, function (status, m) {
          if (m.checked &&
            (m.cores === '1' && deal.cpu.cores === 1)) {
            return true;
          } else if (m.checked &&
            (m.cores === '2' && deal.cpu.cores === 2)) {
            return true;
          } else if (m.checked &&
            (m.cores === '4' && deal.cpu.cores === 4)) {
            return true;
          } else if (m.checked &&
            (m.cores === '6+' && deal.cpu.cores >= 6)) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.ramSizes) {
        if (m.checked && !reduce(filterCategories.ramSizes, function (status, m) {
          if (m.checked &&
            (m.ramSize === 1 && deal.ram.size <= 1)) {
            return true;
          } else if (m.checked &&
            (m.ramSize === 2 && deal.ram.size > 1 && deal.ram.size <= 2)) {
            return true;
          } else if (m.checked &&
            (m.ramSize === 4 && deal.ram.size > 2 && deal.ram.size <= 4)) {
            return true;
          } else if (m.checked &&
            (m.ramSize === 8 && deal.ram.size > 4 && deal.ram.size <= 8)) {
            return true;
          } else if (m.checked &&
            (m.ramSize === 16 && deal.ram.size > 8 && deal.ram.size <= 16)) {
            return true;
          } else if (m.checked &&
            (m.ramSize === 32 && deal.ram.size >= 32)) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.hdTypes) {
        if (m.checked && !reduce(filterCategories.hdTypes, function (status, m) {
          if (m.checked &&
            (m.type !== 'SSD + HDD/Hybrid')) {
            for (const hd of deal.hardDisks) {
              if (m.type === hd.type) {
                return true;
              }
            }
          } else if (m.checked &&
            (m.type === 'SSD + HDD/Hybrid' &&
              deal.hardDisks.length >= 2 &&
              deal.hardDisks[0].type === 'SSD' &&
              (deal.hardDisks[1].type === 'HDD' ||
                deal.hardDisks[1].type === 'Hybrid'))) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      const totalStorage = reduce(deal.hardDisks, function (sum, m) {
        return sum + m.size;
      }, 0);
      for (const m of filterCategories.hdSizes) {
        if (m.checked && !reduce(filterCategories.hdSizes, function (status, m) {
          if (m.checked &&
            (m.hdSize === 128 && totalStorage < 256)) {
            return true;
          } else if (m.checked &&
            (m.hdSize === 256 && totalStorage >= 256 && totalStorage < 512)) {
            return true;
          } else if (m.checked &&
            (m.hdSize === 512 && totalStorage >= 512 && totalStorage < 1000)) {
            return true;
          } else if (m.checked &&
            (m.hdSize === 1000 && totalStorage >= 1000 && totalStorage < 2000)) {
            return true;
          } else if (m.checked &&
            (m.hdSize === 2000 && totalStorage >= 2000)) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.gpuTypes) {
        if (m.checked && !reduce(filterCategories.gpuTypes, function (status, m) {
          if (m.checked &&
            m.type.toLocaleUpperCase() === deal.gpu.type.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.gpuManufacturers) {
        if (m.checked && !reduce(filterCategories.gpuManufacturers, function (status, m) {
          if (m.checked &&
            m.manufacturer.toLocaleUpperCase() === deal.gpu.manufacturer.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.gpuRamSizes) {
        if (m.checked && !reduce(filterCategories.gpuRamSizes, function (status, m) {
          if (m.checked &&
            m.gpuRamSize === deal.gpu.vram) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      for (const m of filterCategories.operatingSystems) {
        if (m.checked && !reduce(filterCategories.operatingSystems, function (status, m) {
          if (m.checked &&
            m.type.toLocaleUpperCase() === deal.operatingSystems[0].type.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }

      const allPorts = [];
      for (const port of deal.ports) {
        allPorts.push(port.type);
      }
      for (const m of filterCategories.portTypes) {
        if (m.checked && !reduce(filterCategories.portTypes, function (status, m) {
          if ((m.checked &&
            allPorts.indexOf(m.portType) !== -1) || !m.checked) {
            return true && status;
          }
          return false;
        }, true)) {
          return false;
        }
      }

      if (filterCategories.opticalDrive.checked && !deal.opticalDrives.length) {
        return false;
      }

      if (filterCategories.webcam.checked && !deal.webcam) {
        return false;
      }

      if (filterCategories.bluetooth.checked && !deal.bluetooth.hasIt) {
        return false;
      }

      return true;
    });
  }

  static sortDeals(deals, sortBy) {
    let sorted;
    switch (sortBy) {
      case 'FEATURED':
        sorted = deals;
        break;
      case 'PRICE-ASCENDING':
        sorted = orderBy(deals, [function (o) {return o.price}], ['asc']);
        break;
      case 'PRICE-DESCENDING':
        sorted = orderBy(deals, [function (o) {return o.price}], ['desc']);
        break;
      case 'A-TO-Z':
        sorted = orderBy(deals, [function (o) {return o.title.toLocaleUpperCase()}], ['asc']);
        break;
      case 'Z-TO-A':
        sorted = orderBy(deals, [function (o) {return o.title.toLocaleUpperCase()}], ['desc']);
        break;
      default:
        sorted = deals;
    };
    return sorted;
  }

  // resets textbox to previous proper value when we navigate away and back
  // to homePage
  resetPriceRangeTextboxes() {
    const newVal = this.props.homePagePriceRangeTextBoxes;
    newVal.lowDisplayed = newVal.lowLongTerm;
    newVal.highDisplayed = newVal.highLongTerm;
    newVal.errors = [];
  }

  handleSearchChange(e, { value }) {
    const val = value;
    this.props.updateHomePageSearchKeyWords(val);
    const filteredDeals = HomePage.filterDeals(this.props.homePageDeals, this.props.homePageLaptopCategories, val);
    const sortedAndFilteredDeals = HomePage.sortDeals(filteredDeals, this.props.homePageSortBy.value);
    this.props.updateHomePageFilteredDeals(sortedAndFilteredDeals);
  }

  handleSearchSubmit(event) {
    console.log('search clicked');
    if (this.props.homePageSearchKeyWords) {
      // this.props.history.push(`/search?keywords=${this.props.homePageSearchKeyWords}`);
    }
  }

  handleResetClick(event) {
    // todo: clean up this messy code and logic
    const dealsProcessed = Array.from(sampleLaptopDeals);
    for (const deal of dealsProcessed) {
      deal.searchDescription =
        deal.title + ' ' +
        '$' + deal.price + ' ' +
        deal.screen.size + '" ' +
        deal.screen.resolution.width + 'X' + deal.screen.resolution.height + ' ' +
        deal.screen.panelType + ' Screen ' +
        deal.cpu.clockSpeed + ' GHZ ' + deal.cpu.cores + '-Core ' + deal.cpu.manufacturer + ' ' +
        deal.cpu.model + ' Processor ' +
        deal.ram.size + ' GB ' + deal.ram.sodimm + ' RAM ' +
        deal.gpu.type + ' ' + deal.gpu.manufacturer + ' ' + deal.gpu.model + ' ' +
        deal.gpu.vram + ' ' + deal.gpu.vram + ' GB  Graphics ' +
        deal.gpu.vram + ' Graphics ' +
        deal.hardDisks[0].size + ' GB ' + deal.hardDisks[0].type + ' ' +
        deal.hardDisks[0].size/1000.0 + ' TB ' + deal.hardDisks[0].type + ' ' +
        deal.weight + ' lbs ';
    }
    this.props.updateHomePageDeals(dealsProcessed);
    this.props.updateHomePageFilteredDeals(dealsProcessed);
    this.populateFilters(dealsProcessed);
    this.props.updateHomePageFilterCategories({
      ...this.props.homePageLaptopCategories,
      priceRange: {
        low: -1,
        high: -1
      },
      panelTypes: [
        {panelType: 'IPS', checked: false},
        {panelType: 'TN', checked: false}
      ],
      touchscreen: {
        checked: false
      },
      weights: [
        {type: 'Feather', checked: false},
        {type: 'Light', checked: false},
        {type: 'Medium', checked: false},
        {type: 'Heavy', checked: false},
        {type: 'Brick', checked: false}
      ],
      cpuManufacturers: [
        {manufacturer: 'AMD', checked: false},
        {manufacturer: 'Intel', checked: false}
      ],
      cpuCores: [
        {cores: '1', checked: false},
        {cores: '2', checked: false},
        {cores: '4', checked: false},
        {cores: '6+', checked: false}
      ],
      ramSizes: [
        {ramSize: 1, checked: false},
        {ramSize: 2, checked: false},
        {ramSize: 4, checked: false},
        {ramSize: 8, checked: false},
        {ramSize: 16, checked: false},
        {ramSize: 32, checked: false}
      ],
      hdTypes: [
        {type: 'SSD', checked: false},
        {type: 'HDD', checked: false},
        {type: 'Hybrid', checked: false},
        {type: 'SSD + HDD/Hybrid', checked: false}
      ],
      hdSizes: [
        {hdSize: 128, checked: false},
        {hdSize: 256, checked: false},
        {hdSize: 512, checked: false},
        {hdSize: 1000, checked: false},
        {hdSize: 2000, checked: false}
      ],
      gpuTypes: [
        {type: 'Integrated', checked: false},
        {type: 'Discrete', checked: false}
      ],
      gpuManufacturers: [
        {manufacturer: 'AMD', checked: false},
        {manufacturer: 'Intel', checked: false},
        {manufacturer: 'Nvidia', checked: false}
      ],
      gpuRamSizes: [],
      operatingSystems: [
        {type: 'Windows', checked: false},
        {type: 'MacOS', checked: false},
        {type: 'ChromeOS', checked: false},
        {type: 'Linux', checked: false}
      ],
      opticalDrive: {
        checked: false
      },
      webcam: {
        checked: false
      },
      bluetooth: {
        checked: false
      }
    });
    this.props.updateHomePagePriceRangeTextBoxes({
      errors: [],
      lowLongTerm: '',
      lowDisplayed: '',
      highLongTerm: '',
      highDisplayed: '',
    });
    this.props.updateHomePageFilteredDeals(this.props.homePageDeals);
  }

  handlePriceRangeTextBoxChange(event) {
    const newVal = {...this.props.homePagePriceRangeTextBoxes};
    newVal[event.target.name] = event.target.value;
    this.props.updateHomePagePriceRangeTextBoxes(newVal);
  }

  handleApply(event) {
    const newVal = {...this.props.homePagePriceRangeTextBoxes};
    // clear errors
    newVal.errors = [];
    this.props.updateHomePagePriceRangeTextBoxes(newVal);

    // check for valid input, display error if invalid
    if (!newVal.lowDisplayed || newVal.lowDisplayed.trim().length === 0) {
      newVal.errors.push('Low price limit cannot be blank');
    }
    if (!newVal.highDisplayed || newVal.highDisplayed.trim().length === 0) {
      newVal.errors.push('High price limit cannot be blank');
    }
    let low = Number(newVal.lowDisplayed);
    let high = Number(newVal.highDisplayed);
    if (Number.isNaN(low)) {
      newVal.errors.push('Low price limit not a valid number');
    }
    if (Number.isNaN(high)) {
      newVal.errors.push('High price limit not a valid number');
    }
    if (low < 0) {
      newVal.errors.push('Low price limit cannot be negative');
    }
    if (high < 0) {
      newVal.errors.push('High price limit cannot be negative');
    }
    if (high < low) {
      newVal.errors.push('High price limit cannot be lower than low price');
    }

    if (newVal.errors.length !== 0) {
      this.props.updateHomePagePriceRangeTextBoxes(newVal);
      return;
    }

    // no errors, so make textbox values longterm and apply price range filter
    newVal.lowLongTerm = newVal.lowDisplayed;
    newVal.highLongTerm = newVal.highDisplayed;
    this.props.updateHomePagePriceRangeTextBoxes(newVal);
    const newFilter = this.props.homePageLaptopCategories;
    newFilter.priceRange.low = Number(newVal.lowLongTerm);
    newFilter.priceRange.high = Number(newVal.highLongTerm);
    this.props.updateHomePageFilterCategories(newFilter);
    const filteredDeals = HomePage.filterDeals(this.props.homePageDeals, this.props.homePageLaptopCategories, this.props.homePageSearchKeyWords);
    const sortedAndFilteredDeals = HomePage.sortDeals(filteredDeals, this.props.homePageSortBy.value);
    this.props.updateHomePageFilteredDeals(sortedAndFilteredDeals);
  }

  // toggle checkbox values and update filter
  handleCheckboxClick(event, data) {
    console.log('checkbox clicked');
    /*
    const newVal = this.props.homePageLaptopCategories;

    if(data.name === 'manufacturer') {
      const index = newVal.manufacturers.findIndex(t => t.brand === data.value);
      newVal.manufacturers[index].checked = !newVal.manufacturers[index].checked;
    }
    if(data.name === 'screenSize') {
      const index = newVal.screenSizes.findIndex(t => {return true});
      newVal.screenSizes[0].checked = data.checked;
    }

    this.props.updateHomePageFilterCategories(newVal);
    */
  }

  handleCheckboxChange(event, data) {
    const newVal = this.props.homePageLaptopCategories;

    if (data.name === 'manufacturer') {
      const index = newVal.manufacturers.findIndex(t => t.brand === data.value);
      newVal.manufacturers[index].checked = !newVal.manufacturers[index].checked;
    }
    if (data.name === 'screenSize') {
      const index = newVal.screenSizes.findIndex(t => Number(t.screenSize) === data.value);
      newVal.screenSizes[index].checked = !newVal.screenSizes[index].checked;
    }
    if (data.name === 'panelType') {
      const index = newVal.panelTypes.findIndex(t => t.panelType === data.value);
      newVal.panelTypes[index].checked = !newVal.panelTypes[index].checked;
    }
    if (data.name === 'resolution') {
      const index = newVal.resolutions.findIndex(t => t.resolution.uniqueKey === data.value);
      newVal.resolutions[index].checked = !newVal.resolutions[index].checked;
    }
    if (data.name === 'touchscreen') {
      newVal.touchscreen.checked = !newVal.touchscreen.checked;
    }
    if (data.name === 'weight') {
      const index = newVal.weights.findIndex(t => t.type === data.value);
      newVal.weights[index].checked = !newVal.weights[index].checked;
    }
    if (data.name === 'cpuManufacturer') {
      const index = newVal.cpuManufacturers.findIndex(t => t.manufacturer === data.value);
      newVal.cpuManufacturers[index].checked = !newVal.cpuManufacturers[index].checked;
    }
    if (data.name === 'cpuCores') {
      const index = newVal.cpuCores.findIndex(t => t.cores === data.value);
      newVal.cpuCores[index].checked = !newVal.cpuCores[index].checked;
    }
    if (data.name === 'ramSize') {
      const index = newVal.ramSizes.findIndex(t => Number(t.ramSize) === data.value);
      newVal.ramSizes[index].checked = !newVal.ramSizes[index].checked;
    }
    if (data.name === 'hdType') {
      const index = newVal.hdTypes.findIndex(t => t.type === data.value);
      newVal.hdTypes[index].checked = !newVal.hdTypes[index].checked;
    }
    if (data.name === 'hdSize') {
      const index = newVal.hdSizes.findIndex(t => t.hdSize === data.value);
      newVal.hdSizes[index].checked = !newVal.hdSizes[index].checked;
    }
    if (data.name === 'gpuType') {
      const index = newVal.gpuTypes.findIndex(t => t.type === data.value);
      newVal.gpuTypes[index].checked = !newVal.gpuTypes[index].checked;
    }
    if (data.name === 'gpuManufacturer') {
      const index = newVal.gpuManufacturers.findIndex(t => t.manufacturer === data.value);
      newVal.gpuManufacturers[index].checked = !newVal.gpuManufacturers[index].checked;
    }
    if (data.name === 'gpuRamSize') {
      const index = newVal.gpuRamSizes.findIndex(t => t.gpuRamSize === data.value);
      newVal.gpuRamSizes[index].checked = !newVal.gpuRamSizes[index].checked;
    }
    if (data.name === 'operatingSystem') {
      const index = newVal.operatingSystems.findIndex(t => t.type === data.value);
      newVal.operatingSystems[index].checked = !newVal.operatingSystems[index].checked;
    }
    if (data.name === 'portType') {
      const index = newVal.portTypes.findIndex(t => t.portType === data.value);
      newVal.portTypes[index].checked = !newVal.portTypes[index].checked;
    }
    if (data.name === 'opticalDrive') {
      newVal.opticalDrive.checked = !newVal.opticalDrive.checked;
    }
    if (data.name === 'webcam') {
      newVal.webcam.checked = !newVal.webcam.checked;
    }
    if (data.name === 'bluetooth') {
      newVal.bluetooth.checked = !newVal.bluetooth.checked;
    }

    this.props.updateHomePageFilterCategories(newVal);
    const filteredDeals = HomePage.filterDeals(this.props.homePageDeals, this.props.homePageLaptopCategories, this.props.homePageSearchKeyWords);
    const sortedAndFilteredDeals = HomePage.sortDeals(filteredDeals, this.props.homePageSortBy.value);
    this.props.updateHomePageFilteredDeals(sortedAndFilteredDeals);
    // Todo: make React detect checkbox change so we don't force a re-render
    this.forceUpdate();
  }

  handleModalOpen(event) {
    this.props.updateHomePageFilterModal(true);
  }

  handleModalClose(event) {
    this.props.updateHomePageFilterModal(false);
  }

  handleDropDownChange(event, data) {
    if (data.value !== this.props.homePageSortBy.value) {
      // only process if changed (in case user selects nothing by clicking elsewhere)
      event.persist();
      this.props.updateHomePageSortBy({value: data.value, text: event.target.textContent});
      const filteredButUnsorted = HomePage.filterDeals(this.props.homePageDeals, this.props.homePageLaptopCategories, this.props.homePageSearchKeyWords);
      const sorted = HomePage.sortDeals(filteredButUnsorted, data.value);
      this.props.updateHomePageFilteredDeals(sorted);
    }
  }

  // accepts capacity in GB
  // returns string in either TB or GB
  beautifyStorage(capacity) {
    if (capacity >= 1000) {
      return (capacity / 1000.0) + ' TB';
    }
    return capacity + ' GB';
  }

  handleReferralButtonClick(type, data) {
    const dealDetails = data.dealdetails;
    window.mixpanel.track('Referral Clicked', {
      title: dealDetails.title,
      link: dealDetails.link,
      manufacturer: dealDetails.manufacturer,
      model: dealDetails.model,
      store: dealDetails.store,
      price: dealDetails.price
    });
  }

  static handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }

  render() {
    const filteredDeals = this.props.homePageFilteredDeals;
    const sortOptions = [
      {
        text: 'Featured',
        value: 'FEATURED'
      },
      {
        text: 'Price: Ascending',
        value: 'PRICE-ASCENDING'
      },
      {
        text: 'Price: Descending',
        value: 'PRICE-DESCENDING'
      },
      {
        text: 'Brand: A to Z',
        value: 'A-TO-Z'
      },
      {
        text: 'Brand: Z to A',
        value: 'Z-TO-A'
      }
    ];

    return <div className="Regular-page ui centered grid">
      <div className="three column row">
        <div className="tablet only computer only three wide column">
        </div>
        <div className="eight wide column">
          <h2 className="ui left aligned header permutize-color">
            Find the Best Laptop Prices
          </h2>
          <div>
            &nbsp;
          </div>
          <div role="list" className="Left-Text ui big list">
            <div role="listitem" className="item">
              <i aria-hidden="true" className="green check icon"></i> Discover deals faster.
            </div>
            <div role="listitem" className="item">
              <i aria-hidden="true" className="green check icon"></i> Powerful search and filtering.
            </div>
            {/*<div role="listitem" className="item">*/}
              {/*<i aria-hidden="true" className="green check icon"></i> Coming Soon: Get deal and price alerts.*/}
            {/*</div>*/}
          </div>
        </div>
        <div className="tablet only computer only two wide column">
        </div>
      </div>
      <div className="one column row">
        {/*<Search*/}
          {/*size={'huge'}*/}
          {/*loading={false}*/}
          {/*onSearchChange={debounce(this.handleSearchChange, 500, { leading: true })}*/}
          {/*value={this.props.homePageSearchKeyWords}*/}
        {/*/>*/}
        <Input
          size="huge"
          placeholder="Search by keyword"
          value={this.props.homePageSearchKeyWords}
          onChange={debounce(this.handleSearchChange, 500, { leading: true })}
          name="searchBox"
          type="text"
        />
      </div>
      <div className="three column row">
        <div className="tablet only computer only four wide column">

        </div>
        <div className="mobile only eleven wide column right aligned">

          <span>
            Sort by{' '}
            <Dropdown
              button
              options={sortOptions}
              onChange={this.handleDropDownChange}
              text={this.props.homePageSortBy.text}
              value={this.props.homePageSortBy.value}
              color="grey"
            />
          </span>

          <Button>
            <Button.Content visible onClick={this.handleModalOpen}>
              Filter <Icon name="filter" />
            </Button.Content>
          </Button>

        </div>
        <div className="tablet only computer only eleven wide column right aligned">

          <span>
            Sort by{' '}
            <Dropdown
              button
              options={sortOptions}
              onChange={this.handleDropDownChange}
              text={this.props.homePageSortBy.text}
              value={this.props.homePageSortBy.value}
              color="grey"
            />
          </span>

        </div>
        <div className="tablet only computer only one wide column">

        </div>
      </div>

      <div className="three column row">
        <div className="tablet only computer only four wide column">

          <NavbarFilter
            laptopFilterCategories={this.props.homePageLaptopCategories}
            errorMessages={this.props.homePagePriceRangeTextBoxes.errors}
            priceRangeLow={this.props.homePagePriceRangeTextBoxes.lowDisplayed}
            priceRangeHigh={this.props.homePagePriceRangeTextBoxes.highDisplayed}
            handlePriceRangeTextBoxChange={this.handlePriceRangeTextBoxChange}
            handleApply={this.handleApply}
            handleReset={this.handleResetClick}
            handleCheckboxChange={this.handleCheckboxChange}
          />

        </div>
        <div className="eleven wide column">

          {filteredDeals && filteredDeals.length === 0 &&
            <div className="permutize-item Center-Text">
              <h1>No results</h1>
            </div>
          }

          <div className="ui divided items">

            {filteredDeals.map(laptopDeal =>
              <div key={`${laptopDeal.store}: ${laptopDeal.title} ${laptopDeal.manufacturer} ${laptopDeal.model}`} className="item permutize-item">
                <div className="ui medium image">
                  <img src={laptopDeal.pictureLink} alt="result"/>
                </div>
                <div className="content">
                  <a className="header" onClick={event => {this.handleReferralButtonClick(event, {dealdetails:laptopDeal})} } target="_blank" rel="noopener noreferrer" href={laptopDeal.link}>
                    {laptopDeal.title}
                  </a>

                  <div className="meta">
                    <h2 className="price-label">
                      ${laptopDeal.price}
                    </h2>
                    <a href={laptopDeal.link} target="_blank" rel="noopener noreferrer">
                      <Button primary onClick={this.handleReferralButtonClick} dealdetails={laptopDeal}>
                        <Button.Content visible>
                          {laptopDeal.storeDisplayName} <Icon name='shop' />
                        </Button.Content>
                      </Button>
                    </a>
                  </div>

                  <div className="description">
                    {laptopDeal.screen.size}" {laptopDeal.screen.resolution.width}X{laptopDeal.screen.resolution.height} {laptopDeal.screen.panelType} Screen<br/>

                    {laptopDeal.cpu.clockSpeed}GHZ {laptopDeal.cpu.cores}-Core {laptopDeal.cpu.manufacturer} {laptopDeal.cpu.model} Processor<br/>
                    {laptopDeal.ram.size}GB {laptopDeal.ram.sodimm} RAM<br/>

                    {laptopDeal.gpu.type} {laptopDeal.gpu.manufacturer} {laptopDeal.gpu.model}
                    {laptopDeal.gpu.vram ? <span> {laptopDeal.gpu.vram} GB </span> : <span></span>} Graphics<br/>

                    {this.beautifyStorage(laptopDeal.hardDisks[0].size)} {laptopDeal.hardDisks[0].type}
                    {laptopDeal.hardDisks.length > 1 ? <span> + {this.beautifyStorage(laptopDeal.hardDisks[1].size)} {laptopDeal.hardDisks[1].type}</span> : <span></span>}<br/>

                    {laptopDeal.weight} lbs
                  </div>
                  {/*Todo: Implement Additional Details popover*/}
                  {/*<div className="extra">Additional Details</div>*/}

                </div>

              </div>
            )}

          </div>
        </div>
        <div className="tablet only computer only one wide column">
        </div>
      </div>

      <Modal closeIcon size={'mini'} onClose={this.handleModalClose} open={this.props.homePageFilterModal}>
        <div className="ui centered grid">
          <div className="three column row">

            <div className="three wide column">
            </div>

            <div className="ten wide column">
              <NavbarFilter
                laptopFilterCategories={this.props.homePageLaptopCategories}
                errorMessages={this.props.homePagePriceRangeTextBoxes.errors}
                priceRangeLow={this.props.homePagePriceRangeTextBoxes.lowDisplayed}
                priceRangeHigh={this.props.homePagePriceRangeTextBoxes.highDisplayed}
                handlePriceRangeTextBoxChange={this.handlePriceRangeTextBoxChange}
                handleApply={this.handleApply}
                handleCheckboxChange={this.handleCheckboxChange}
              />
            </div>

            <div className="three wide column">
            </div>

          </div>
        </div>
      </Modal>
    </div>
  }

}

export default connect(
  (state) => ({
    homePageDataFetched: state.homePage.homePageDataFetched,
    homePageFilterModal: state.homePage.homePageFilterModalVisible,
    homePageSortBy: state.homePage.homePageSortBy,
    homePageDeals: state.homePage.homePageDeals,
    homePageFilteredDeals: state.homePage.homePageFilteredDeals,
    homePagePriceRangeTextBoxes: state.homePage.homePagePriceRangeTextBoxes,
    homePageLaptopCategories: state.homePage.homePageLaptopCategories,
    homePageSearchKeyWords: state.homePage.homePageSearchKeyWords,
  }),
  {
    updateHomePageDataFetched,
    updateHomePageFilterModal,
    updateHomePageSortBy,
    updateHomePageDeals,
    updateHomePageFilteredDeals,
    updateHomePagePriceRangeTextBoxes,
    updateHomePageFilterCategories,
    updateHomePageSearchKeyWords
  }
)(HomePage);


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js